/**
 * ProShip Design System — Effects (Foundation Layer)
 */
import {PRIMARY_BLUE, BORDER} from './colors'

export const TRANSITION = {
  fast: 'all 0.15s ease',
  normal: 'all 0.2s ease',
}

export const HOVER = {
  lift: {
    transition: TRANSITION.normal,
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    },
  },
  highlight: {
    transition: TRANSITION.fast,
    '&:hover': {
      borderColor: PRIMARY_BLUE,
      bgcolor: PRIMARY_BLUE + '08',
    },
  },
}

export const SHADOW = {
  card: '0 2px 8px rgba(0,0,0,0.06)',
  cardHover: '0 8px 24px rgba(0,0,0,0.10)',
  sticky: '0 -4px 12px rgba(0,0,0,0.06)',
}
